import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getFormList = (axios: IAxiosInstance) => {
  return async (params: ISchema["#/definitions/TGetFormListQuery"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/TGetFormListResponse"]
    >(`/forms/list`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
